import { createContext } from 'react';

const initialState = {
  shoppingList: JSON.parse(localStorage.getItem('shoppingList')) || [],
  recipeHistory: JSON.parse(localStorage.getItem('recipeHistory')) || [],
  customLists: JSON.parse(localStorage.getItem('customLists')) || [],
  theme: 'light',
  shoppingMode: JSON.parse(localStorage.getItem('shoppingMode')) || false,
  themeColor: localStorage.getItem('themeColor') || '#1890ff',
  user: null,
  isLoading: true
};

const AppContext = createContext(initialState);

export default AppContext; 